module.exports = __webpack_public_path__ + "static/media/branch.6b79c9e7.svg";